(() => {
  'use strict';
  const loader = document.getElementById('astra-clarity-loader');
  if (!loader || loader.dataset.initialized || window.Shopify?.designMode) return;
  loader.dataset.initialized = 'true';
  const project = loader.dataset.projectId;
  if (!/^[a-z0-9]+$/i.test(project || '')) return;
  let requested = false;
  let revoked = false;
  let consentAllowed = false;
  let privacyLoading = false;
  let attempts = 0;

  const state = value => { loader.dataset.state = value; };
  const signal = allowed => {
    window.clarity('consentv2', {
      ad_Storage: 'denied',
      analytics_Storage: allowed ? 'granted' : 'denied'
    });
  };
  const revoke = () => {
    consentAllowed = false;
    if (requested && !revoked) {
      revoked = true;
      signal(false);
      window.clarity('stop');
    }
    state(revoked ? 'revoked-until-next-page' : 'consent-denied');
  };
  const initialize = () => {
    if (revoked) {
      state('revoked-until-next-page');
      return;
    }
    if (requested) return;
    if (window.clarity || document.querySelector('script[src*="clarity.ms/tag/"]')) {
      state('existing-installation');
      return;
    }
    requested = true;
    window.clarity = function () {
      (window.clarity.q = window.clarity.q || []).push(arguments);
    };
    signal(true);
    window.clarity('metadata', () => {
      if (consentAllowed && !revoked) state('initialized');
    }, false);
    const tag = document.createElement('script');
    tag.async = true;
    tag.src = 'https://www.clarity.ms/tag/' + project;
    tag.onerror = () => state('load-error');
    state('loading');
    document.head.appendChild(tag);
  };
  const sync = () => {
    const privacy = window.Shopify?.customerPrivacy;
    if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function') {
      revoke();
      state('privacy-unavailable');
      return;
    }
    try {
      consentAllowed = privacy.analyticsProcessingAllowed() === true;
      if (consentAllowed) initialize();
      else revoke();
    } catch (_) {
      revoke();
      state('privacy-error');
    }
  };
  const connect = () => {
    if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed) {
      sync();
      return;
    }
    if (privacyLoading) return;
    if (window.Shopify?.loadFeatures) {
      privacyLoading = true;
      try {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], error => {
          privacyLoading = false;
          if (error) state('privacy-error');
          else sync();
        });
      } catch (_) {
        privacyLoading = false;
        state('privacy-error');
      }
    } else if (attempts++ < 20) {
      window.setTimeout(connect, 250);
    } else {
      state('privacy-unavailable');
    }
  };
  document.addEventListener('visitorConsentCollected', connect);
  window.addEventListener('pageshow', connect);
  connect();
})();

